module.exports = __webpack_public_path__ + "static/media/bg-auth.47ce0932.PNG";